import { useMemo, useSyncExternalStore } from "react";

export function useMediaQuery(query: string) {
  const store = useMemo(() => {
    const media = window.matchMedia(query);
    return {
      subscribe: (onChange: () => void) => {
        media.addEventListener("change", onChange);
        return () => media.removeEventListener("change", onChange);
      },
      getSnapshot: () => media.matches,
    };
  }, [query]);

  return useSyncExternalStore(store.subscribe, store.getSnapshot);
}
